module.exports = __webpack_public_path__ + "img/51626529.bdca4bd3.png";